import { useCallback, useEffect, useState } from 'react';

import getTownshipRange, {
  TownshipRange,
} from '@/endpoints/township-range/getTownshipRange';

import {
  SearchResult,
  SearchResultGeometry,
  SearchResultType,
} from '../models';

export const useTownshipRangeSearch = (location: string) => {
  const [townships, setTownships] = useState<SearchResult<TownshipRange>[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setTownships([]);
  }, [location]);

  const fetchTownships = useCallback(
    async (signal: AbortSignal) => {
      if (!location) return;

      setLoading(true);
      try {
        const { res, err } = await getTownshipRange(
          {
            includes__geometry: true,
            limit: 5,
            offset: 0,
            township_range__startswith: location,
          },
          signal
        );
        if (err) {
          throw err;
        }

        if (res) {
          setTownships(
            res.data?.results.splice(0, 5).map((x) => ({
              geometry: x.geometry as SearchResultGeometry,
              id: `township-range-${x.label}`,
              label: `${x.short_label}, ${x.state}`,
              original: x,
              type: SearchResultType.TOWNSHIP_RANGE,
            }))
          );
        }
      } catch (err) {
        return;
      } finally {
        setLoading(false);
      }
    },
    [location]
  );

  useEffect(() => {
    const abortController = new AbortController();
    fetchTownships(abortController.signal);

    return () => {
      abortController.abort();
    };
  }, [fetchTownships]);

  return {
    loading,
    townships,
  };
};
